import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const ItemWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
}

export const NameStyle: React.CSSProperties = {
  ...sharedStyles.text,
  ...sharedStyles.textSecondary,
}

export const DescriptionStyle: React.CSSProperties = {
  ...sharedStyles.text,
}

export const BorderBottomStyle: React.CSSProperties = {
  height: toPx(sharedStyles.BorderWidth.SMALL),
  marginTop: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  marginBottom: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  backgroundColor: sharedStyles.Colors.Tints.NEUTRAL[5],
}

export const BorderBottomLastStyle: React.CSSProperties = {
  ...BorderBottomStyle,
  marginBottom: toPx(0),
}
